<template>
  <div style="display: grid;">
    <button @click="openModal()" class="btn btn-outline-light"><i class="fa-regular fa-building"></i> Simulate Bank Transfer</button>

    <!-- alert modal for confirmation -->
    <alert-modal v-if="isAlertOpen">
      <span><i class="fa-solid fa-circle-check"></i>Payment sucessfully created</span>
    </alert-modal>

    <!-- modal -->
    <div class="modal-container" v-if="isModalOpen">
      <div class="modal-content">
        <h1>Make Payment<i @click="closeModal()" class="fa-regular fa-xmark"></i></h1>
        <span style="font-weight: normal; color: #717182;">Submit a payment for this order. All fields are pre-filled but can be edited.</span>
        
        <div style="display: grid;">
          <span class="filter-item-title">VIBAN*</span>
          <input type="text" class="filter-item-content" placeholder="VIBAN..." v-model="payment.VIBAN" @input="event => payment.VIBAN = sanitize(event.target.value)"/>
        </div>

        <div style="display: grid;">
          <span class="filter-item-title">Amount (EUR)*</span>
          <input type="number" class="filter-item-content" placeholder="0.00" v-model="payment.amount" @input="event => payment.amount = sanitize(event.target.value)"/>
        </div>

        <div style="display: grid;">
          <span style="font-weight: bold;">Payment Date*</span>
          <datetime-picker class="z-1" format="DD/MM/YYYY"
            :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin, 'error-datepicker': dateBeginError}"
            customInputParentClass="filter-item-content"
            :maxLength="19"
            :placeholderValue="$t('common.datetime_picker_empty_date')"
            inputIcon="fa-solid fa-calendar"
            v-model="dateBegin">
          </datetime-picker>
          <span v-if="dateBeginError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
        </div>

        <div style="display: grid;">
          <span class="filter-item-title">Remittance Reference</span>
          <input type="text" class="filter-item-content" placeholder="Payment reference (optional)" v-model="payment.reference" @input="event => payment.reference = sanitize(event.target.value)"/>
        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr; align-items: center; gap: 1rem; margin-top: 2rem;">
          <button class="btn-outline btn-dark" @click="submit()">Submit Payment</button>
          <button class="btn-outline-light btn" @click="closeModal()">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateTimePicker from '@/components/common/dateTimePicker.vue';
import AlertModal from './alertModal.vue';
export default {
  components: {
    'datetime-picker': DateTimePicker,
    'alert-modal': AlertModal
  },
  name: 'makePaymentModal',
  props: {
    payment: Object
  },
  data(){
    return {
      isModalOpen: false,
      dateBegin: '',
      dateBeginError: '',
      isAlertOpen: false,
    }
  },
  created(){
    this.dateBegin = new Date(this.payment.paymentDate).toLocaleDateString()
  },
  methods: {
    openModal (){
      this.isModalOpen = true
    },
    closeModal (){
      this.isModalOpen = false
      this.payment = {
        VIBAN: null,
        amount: null,
        date: null,
        reference: null
      }
    },
    formatDate (dateStr) {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month}-${day}`;
    },
    submit(){
      this.$engine.services.payments.getGroups({ search : this.payment.VIBAN , maxResults : 400})
      .then(res => {
        if(res.data.references.length == 0){
          return
        } else{
          let data = {
            "ExecutionDate": new Date(this.payment.paymentDate).toISOString(),
            "Amount": this.payment.amount,
            "VIBAN": this.payment.VIBAN,
            "RefTransaction": this.payment.reference
          }
          this.$engine.services.payments.createPaymentSimulation(data)
          .then(resp => {
            if(resp.data.status == 'OK'){
              this.isAlertOpen = true
              setTimeout(()=>{
                this.isAlertOpen = false;
              }, 3000)
              this.closeModal()
            }
          })
        }
      })
      .catch(err => console.log(err))
    },
    sanitize(value) {
      if (typeof value !== 'string') return ''

      return value
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9-_]/g, '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\r?\n|\r/g, '')
    }
  }
}
</script>
<style scoped>

small{
  color: #6a7282;
  font-size: 0.85rem;
  margin: 0.25rem 0rem;
}

.modal-container{
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  overflow: hidden;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content .filter-item {
  margin: 1rem 0rem;
}

.modal-content>h1{
  font-weight: bold;
  font-size: 1.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
}

.modal-content>h1>i{
  cursor: pointer;
}

.modal-content>input{
  margin-bottom: 1.5rem;
}

.modal-content>span:first-of-type{
  color: #717182;
  margin-bottom: 1rem;
}

.modal-content>span:last-of-type{
  color: #000;
  font-weight: bold;
}
</style>